import React from "react";

const ChevronSVG = () => {
    return (
        <svg width="14" height="14" viewBox="0 0 26 14" fill="none" xmlns="http://www.w3.org/2000/svg" className="no-fill">
            <path d="M25 1.01221L13 12.0245L0.999998 1.01221" stroke="black" strokeWidth="3"/>
        </svg>
    );
};

export default ChevronSVG;
